const BLOGS_API = process.env.REACT_APP_BLOGS_API_URL || 'http://localhost:8080/api/blogs.php';
const BLOG_API = process.env.REACT_APP_BLOG_API_URL || 'http://localhost:8080/api/blog.php';

export async function fetchPublishedBlogs() {
  const response = await fetch(BLOGS_API, { cache: 'no-store' });  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Unable to load blogs');
  }

  return data.blogs || [];
}

export async function fetchPublishedBlog(id) {
  const response = await fetch(`${BLOG_API}?id=${id}`, { cache: 'no-store' });  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Unable to load article');
  }

  return data.blog;
}
